'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('LoginCtrl', function($location, $scope, $window, $controller, $timeout,
    AuthenticationService, FlashService, eventsService) {

    var loginVm = this;
    $controller('BaseController', {
      vm: loginVm
    });

    var returnUrl = $location.search().returnUrl;

    loginVm.loggedIn = AuthenticationService.loggedIn();
    loginVm.login = login;
    loginVm.logout = logout;
    loginVm.tfaRequired = false;

    loginVm.loginData = {
      userName: loginVm.username,
      password: loginVm.password
    };

    loginVm.baseActivate(activate);

    function activate() {
      if (loginVm.loggedIn) {
        $location.path('/');
      }
    }

    function login() {
      loginVm.loginData.password = $window.encodeURIComponent(loginVm.loginData.password);

      if (loginVm.tfaRequired) {
        loginVm.tfaData.tfaCode = loginVm.loginData.tfaCode;
        loginVm.loginData = loginVm.tfaData;
      }

      loginVm.requestStart()
        .then(AuthenticationService.Login.bind(null, loginVm.loginData))
        .then(function(response) {
          loginVm.loggedIn = true;
          eventsService.loggedIn();
          $timeout($window.gfcmsUI.setupAccordion, 500);

          if (returnUrl) {
            $location.search({});
            $location.path(returnUrl);
          } else {
            $location.path('/');
          }
        })
        .catch(function(error) {
          var message = /*error.status === 401 ? 'Incorrect username or password' : */ error.message;
          loginVm.tfaRequired = loginVm.tfaRequired || error.tfaRequired;
          if (loginVm.tfaRequired) {
            loginVm.tfaData = angular.copy(loginVm.loginData);
          } else {
            loginVm.loginData.tfaCode = '';
            FlashService.Error(message, false);
          }
        })
        .finally(loginVm.requestComplete.bind(loginVm));
    }

    function logout() {
      AuthenticationService.ClearCredentials();
      $window.location.reload();
    }
  });
